import React, { memo, useMemo } from "react";
import { Col, Form, Row, Container as BootContainer } from "react-bootstrap";
import { useSource, useSourceReducer } from "../../../../sourceContext";
import { NAR, REC } from "../../../../../../shared/Data/typeDirs";
import { langTypeMap } from "../../../../../../shared/Data/langTypeMap";
import { getOptionsForLanguageEntryDropdown } from "../../../../../../scripts/reactBased/dataObjectHelpers";




export function EditAllItemsForm({ name }) {

  const source = useSource()
  const sourceReducer = useSourceReducer()
  const { [name]: categorySource, [langTypeMap[name].getParentKey()]: parentSource } = source
  const {
    formDataKeys,
    colWidths,
    isLangEntry
  } = useMemo(() => {
    return {
      formDataKeys: langTypeMap[name].getFormSchema(getOptionsForLanguageEntryDropdown),
      colWidths: langTypeMap[name].getFormColWidths(),
      isLangEntry: [REC, NAR].includes(name)
    }
  }, [name])

  return (
    <FormControls
      isLangEntry={isLangEntry}
      colWidths={colWidths}
      formDataKeys={formDataKeys}
      name={name}
      source={categorySource}
      parentSource={parentSource}
      sourceReducer={sourceReducer}
    />
  )
}

const FormControls = memo(function ({ isLangEntry, source, colWidths, formDataKeys, name, parentSource, sourceReducer }) {
  // console.log('rendering FormControls')
  let parentLabel = isLangEntry ? (
    <Col sm={colWidths.parent}> Parent </Col>
  ) : []
  let formItems = []
  for (let i = 0; i < source.length; i++) {

    formItems.push(
      <Control
        idx={i}
        key={i}
        isLangEntry={isLangEntry}
        colWidths={colWidths}
        formDataKeys={formDataKeys}
        name={name}
        sourceReducer={sourceReducer}
        parent={parentSource && parentSource.find(parentItem => {
          return parentItem._id === source[i][langTypeMap[name].getParentAddress()]
        }).getDisplayText()}        
        sourceItem={source[i]}
      />
    )
  }
  // console.log('making form items with name and sl', name, source.length, formDataKeys, formItems)
  return (
    <Form>
      <BootContainer style={{ position: 'relative' }}>
        <Row
          key="labels"
          className="g-0"
          style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 99999999999999 }}
        >
          {parentLabel}
          {formDataKeys.map((fdk, labelIdx) => {
            return (
              <Col key={labelIdx} style={{ margin: 'auto', textAlign: 'center' }} sm={colWidths[fdk.name]}>
                <Form.Label>{fdk.name}</Form.Label>
              </Col>
            )
          })}
        </Row>
        {formItems}
      </BootContainer>
    </Form>
  )
})

const Control = memo(function ({ idx, parent, sourceItem, isLangEntry, colWidths, sourceReducer, formDataKeys }) {
  // if(!sourceItem) return []
  let changeTimeoutId

  console.log('getting control', sourceItem)
  const formData = sourceItem.getFormData()

  let parentlabel = []
  if (isLangEntry) {

    let [num, ...rest] = parent.split(' ')

    parentlabel = (
      <Col sm={colWidths.parent} style={{ margin: 'auto' }}>
        <Row style={{ margin: 'auto' }}>
          <Form.Label>{num}</Form.Label>
        </Row>
        <Row style={{ margin: 'auto' }}>
          <Form.Label>{rest.join(' ')}</Form.Label>
        </Row>

      </Col>
    )
  }

  function onChange(value, item) {
    clearTimeout(changeTimeoutId)
    changeTimeoutId = setTimeout(() => {
      // console.log('changing in edit all', item.name, value, item)
      sourceReducer({ item: sourceItem, type: 'content_change', value: value, address: item.name, idx })
    }, 500)
  }

  const backgroundColor = sourceItem._changed ? '#F08080CC' : (idx % 2) === 0 ? 'whitesmoke' : 'white'
  return (
    <Row key={idx} style={{ backgroundColor }} className="g-0">
      {parentlabel}
      {formDataKeys.map((i, fkIdx) => {
        return (
          <Col key={fkIdx} style={{ margin: 'auto' }} sm={colWidths[i.name]}>
            <Form.Control
              id={i.name}
              {...i}
              style={sourceItem._changed ? { borderColor: backgroundColor } : {}}
              defaultValue={formData[i.name]}
              onChange={(evt) => onChange(evt.target.value, i)} />
          </Col>
        )
      })}
    </Row>
  )
})